import { TooltipProvider } from "~/react/ui/tooltip"
import { CampaignContentProvider } from "./campaign_content_context"
import { CampaignContentSidebar } from "./sidebar/campaign_content_sidebar"
import { FollowUpEditor } from "./editor/follow_up_editor"
import type { CampaignContentProps } from "./types"

export function CampaignContent({
  campaign,
  followUps,
  editable,
  canAddFollowUp,
  maxFollowUps,
  messageTemplates,
  allowEmailAttachments,
  allowEmailImages,
  allowVideoLinks,
  currentUserEmail,
}: CampaignContentProps) {
  return (
    <TooltipProvider>
      <CampaignContentProvider
        campaign={campaign}
        followUps={followUps}
        editable={editable}
        canAddFollowUp={canAddFollowUp}
        maxFollowUps={maxFollowUps}
        messageTemplates={messageTemplates}
        allowEmailAttachments={allowEmailAttachments}
        allowEmailImages={allowEmailImages}
        allowVideoLinks={allowVideoLinks}
        currentUserEmail={currentUserEmail}
      >
        <div className="campaign-content-editor">
          <CampaignContentSidebar />
          <main className="campaign-content-editor__main">
            <FollowUpEditor />
          </main>
        </div>
      </CampaignContentProvider>
    </TooltipProvider>
  )
}
